import { render } from "./PieChartPanel.vue?vue&type=template&id=509766d5&ts=true"
import script from "./PieChartPanel.vue?vue&type=script&lang=ts"
export * from "./PieChartPanel.vue?vue&type=script&lang=ts"

import "./PieChartPanel.vue?vue&type=style&index=0&id=509766d5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QChip,QTooltip,QMenu,QInput,QItemSection,QSpace,QSeparator,QSelect,QItem});qInstall(script, 'directives', {ClosePopup});
